import { FC, SVGAttributes } from 'react';

const Pause: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 16L10 8M14 16V8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                stroke="#282828"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default Pause;
